module.exports = __webpack_public_path__ + "img/danarupiah.acf43dc8.png";